import React, { useRef, useState } from 'react';
import { Move } from 'lucide-react';

const KEYWORD_MAP = {
  center: '50% 50%',
  top: '50% 0%',
  bottom: '50% 100%',
  left: '0% 50%',
  right: '100% 50%',
};

export const parsePosition = (v) => {
  const s = KEYWORD_MAP[v] || v || '50% 50%';
  const m = String(s).match(/([\d.]+)%\s+([\d.]+)%/);
  return m ? { x: parseFloat(m[1]), y: parseFloat(m[2]) } : { x: 50, y: 50 };
};

export const FocalPointPicker = ({ src, value, onChange, onCommit, fitMode = 'cover', className = '' }) => {
  const containerRef = useRef(null);
  const imgRef = useRef(null);
  const dragRef = useRef(null);
  const [dragging, setDragging] = useState(false);
  const pos = parsePosition(value);

  const moveDrag = (e) => {
    const d = dragRef.current;
    const img = imgRef.current;
    const box = containerRef.current?.getBoundingClientRect();
    if (!d || !img || !box || !img.naturalWidth) return;
    const scale = Math.max(box.width / img.naturalWidth, box.height / img.naturalHeight);
    const overflowX = img.naturalWidth * scale - box.width;
    const overflowY = img.naturalHeight * scale - box.height;
    let x = d.posX;
    let y = d.posY;
    if (overflowX > 1) x = Math.min(100, Math.max(0, d.posX - ((e.clientX - d.startX) / overflowX) * 100));
    if (overflowY > 1) y = Math.min(100, Math.max(0, d.posY - ((e.clientY - d.startY) / overflowY) * 100));
    d.last = `${Math.round(x * 10) / 10}% ${Math.round(y * 10) / 10}%`;
    onChange(d.last);
  };

  const endDrag = () => {
    window.removeEventListener('pointermove', moveDrag);
    window.removeEventListener('pointerup', endDrag);
    setDragging(false);
    if (dragRef.current && onCommit) onCommit(dragRef.current.last);
    dragRef.current = null;
  };

  const startDrag = (e) => {
    if (fitMode !== 'cover') return;
    e.preventDefault();
    dragRef.current = { startX: e.clientX, startY: e.clientY, posX: pos.x, posY: pos.y, last: `${pos.x}% ${pos.y}%` };
    setDragging(true);
    window.addEventListener('pointermove', moveDrag);
    window.addEventListener('pointerup', endDrag);
  };

  return (
    <div
      ref={containerRef}
      onPointerDown={startDrag}
      className={`relative overflow-hidden select-none touch-none ${fitMode === 'cover' ? (dragging ? 'cursor-grabbing' : 'cursor-grab') : ''} ${className}`}
      data-testid="focal-point-picker"
    >
      <img
        ref={imgRef}
        src={src}
        alt=""
        draggable={false}
        className="w-full h-full pointer-events-none"
        style={{ objectFit: fitMode, objectPosition: `${pos.x}% ${pos.y}%` }}
      />
      {fitMode === 'cover' && (
        <div className={`absolute bottom-2 left-1/2 -translate-x-1/2 flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-black/60 text-white text-xs pointer-events-none whitespace-nowrap transition-opacity ${dragging ? 'opacity-0' : 'opacity-90'}`}>
        <Move className="w-3 h-3" />
          Arraste para posicionar
        </div>
      )}
    </div>
  );
};
